import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import RecapDefinition from './recaps/RecapDefinition.vue'
import BaseModal from './wrappers/BaseModal.vue'
import { useModelWrapper } from './wrappers/helpers/useModelWrapper'
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalRecapPreview',
  props: {
    recapId: {},
    recapType: {},
    modelValue: { type: Boolean }
  },
  emits: ["continueToLegal", "update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const value = useModelWrapper(props, emit)

const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`form.${key}`)

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(BaseModal, {
    modelValue: _unref(value),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(label('recapPreview')), 1)
    ]),
    content: _withCtx(() => [
      _createVNode(RecapDefinition, {
        "recap-id": _ctx.recapId,
        "recap-type": _ctx.recapType,
        "task-or-store-id": '0',
        "existing-recap-response": undefined,
        "testing-recap": true,
        "preview-recap": true
      }, null, 8, ["recap-id", "recap-type"])
    ]),
    actions: _withCtx(() => [
      _withDirectives(_createVNode(_component_q_btn, {
        rounded: "",
        flat: "",
        label: label('close')
      }, null, 8, ["label"]), [
        [_directive_close_popup]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})